/* Imagine Creation — ราคาประมาณการ: กล่องรายละเอียดระดับงบ · บันไดราคา · กล่องงบตัวอย่าง (ใช้ได้ทุกหน้า) */
(function () {
  if (window.__icPx) return;
  window.__icPx = true;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
  var sheet = null;

  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function setOpen(px, on) {
    px.classList.toggle('is-open', on);
    var b = px.querySelector('.px__btn');
    if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function closeAll(except) { each('.px.is-open', function (p) { if (p !== except) setOpen(p, false); }); }
  function openSheet(px) {
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'px-sheet';
      sheet.innerHTML = '<div class="px-sheet__bg" data-px-close></div><div class="px-sheet__box" role="dialog" aria-modal="true"></div>';
      document.body.appendChild(sheet);
    }
    var box = sheet.querySelector('.px-sheet__box');
    box.innerHTML = px.querySelector('.px__pop').innerHTML;
    sheet.classList.add('is-open');
    var x = box.querySelector('.px__x');
    if (x) x.focus();
  }
  function closeSheet() { if (sheet) sheet.classList.remove('is-open'); }
  function setLadder(l, on) {
    l.classList.toggle('is-open', on);
    var s = l.querySelector('.pxl__sum');
    if (s) s.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  /* ── กล่องงบตัวอย่าง ── */
  function full(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function mil(n) { return String(Math.round(n / 10000) / 100); }
  function calc(root) {
    var area = +root.getAttribute('data-area') || 0;
    var tb = root.querySelector('[data-pxb-tier][aria-pressed="true"]');
    var t = tb ? tb.getAttribute('data-pxb-tier') : '2';
    var r = (root.getAttribute('data-t' + t) || '0-0').split('-');
    var a1 = area * (+r[0] || 0), a2 = area * (+r[1] || 0);
    each('[data-pxb-add][aria-pressed="true"]', function (c) {
      var q = +c.getAttribute('data-qty') || 0;
      a1 += q * (+c.getAttribute('data-min') || 0);
      a2 += q * (+c.getAttribute('data-max') || 0);
    }, root);
    var v = root.querySelector('[data-pxb-val]');
    if (v) v.innerHTML = a2 >= 1e6 ? mil(a1) + '–' + mil(a2) + ' <small>ล้านบาท</small>' : full(a1) + '–' + full(a2) + ' <small>บาท</small>';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('.px__btn');
    if (b) {
      var px = b.closest('.px');
      var on = !px.classList.contains('is-open');
      closeAll(px);
      if (mq && mq.matches) { setOpen(px, false); if (on) openSheet(px); return; }
      setOpen(px, on);
      return;
    }
    if (t.closest('[data-px-close]')) { closeAll(); closeSheet(); return; }
    if (!t.closest('.px__pop')) closeAll();

    var lt = t.closest('[data-pxl-toggle]');
    if (lt) { var l = lt.closest('[data-pxl]'); setLadder(l, !l.classList.contains('is-open')); return; }

    var tier = t.closest('[data-pxb-tier]');
    if (tier) {
      var root = tier.closest('[data-pxb]');
      each('[data-pxb-tier]', function (x) { x.setAttribute('aria-pressed', x === tier ? 'true' : 'false'); }, root);
      calc(root);
      return;
    }
    var add = t.closest('[data-pxb-add]');
    if (add) {
      add.setAttribute('aria-pressed', add.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      calc(add.closest('[data-pxb]'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAll(); closeSheet();
    each('.pxl.is-open', function (l) { setLadder(l, false); });
  });
  /* เมาส์ออกจากการ์ด → พับบันไดที่เปิดค้างจากการคลิก */
  var canHover = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
  document.addEventListener('mouseleave', function (e) {
    if (!canHover || !canHover.matches) return;
    var h = e.target;
    if (!h || !h.matches || !h.matches('[data-pxl-host]')) return;
    each('.pxl.is-open', function (l) { setLadder(l, false); }, h);
  }, true);
})();
